import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import InformeEventoService from "../../services/informe-evento.service";
import { InformeEvento, isInformeVigente } from "../@types/informeEvento";

interface InformesEventoContextData {
  informes: InformeEvento[];
  total: number;
  loading: boolean;
  error: boolean;
  reload: () => void;
}

const InformesEventoContext = createContext<InformesEventoContextData>({
  informes: [],
  total: 0,
  loading: false,
  error: false,
  reload: () => undefined,
});

interface Props {
  children: React.ReactNode;
}

export function InformesEventoProvider({ children }: Props) {
  const [informes, setInformes] = useState<InformeEvento[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);

  const carregar = useCallback(() => {
    const service = new InformeEventoService();
    setLoading(true);
    setError(false);
    service
      .getVigentes()
      .then((res) => {
        const lista = Array.isArray(res.result) ? res.result : [];
        setInformes(lista.filter((informe) => isInformeVigente(informe)));
      })
      .catch((err) => {
        console.error("Erro ao carregar informes vigentes:", err);
        setInformes([]);
        setError(true);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    carregar();
  }, [carregar]);

  const value = useMemo<InformesEventoContextData>(
    () => ({
      informes,
      total: informes.length,
      loading,
      error,
      reload: carregar,
    }),
    [informes, loading, error, carregar]
  );

  return (
    <InformesEventoContext.Provider value={value}>
      {children}
    </InformesEventoContext.Provider>
  );
}

export function useInformesEvento(): InformesEventoContextData {
  return useContext(InformesEventoContext);
}

export default InformesEventoContext;
